import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { Input, InputNumber, message } from 'antd';
import { CloseOutlined, CheckOutlined, CloseCircleOutlined, StarOutlined, CheckCircleOutlined } from '@ant-design/icons';

import SingleOption from './options/single-option';
import Spinner from '../../../components/Spinner';
import { QuestionListItem, QuestionItem } from '../types';
import MultiOption from './options/multi-option';
import JudgeOption from './options/judge-option';
import CompletionOption from './options/completion-option';
import AnswerOption from './options/answer-option';
import { optionsNum, lookStatus, LookStatus } from '../constant';
import { addStar, removeStar } from '../api';

interface IProps {
  testInfo: { id: string, name: string };
  questionList: QuestionListItem[];
  setQuestionList: (data: QuestionListItem[]) => void;
}

function QuestionList({ testInfo, questionList, setQuestionList }: IProps) {
  const [isLoading, setIsLoading] = useState(false);
  const urlParams: { id: string, type: LookStatus } = useParams();
  const isReview = urlParams.type === lookStatus.review;
  const isSee = urlParams.type === lookStatus.see;
  const isView = urlParams.type === lookStatus.view;

  function computedCount(data: QuestionItem[]): number {
    let totalCount = 0;
    data.map(item => {
      totalCount += item.grade;
    })
    return totalCount;
  }

  function renderOptions(type: number, ques: QuestionItem) {
    const { options, myAnswer, disabled=false } = ques;
    if (type === 1) {
      return <SingleOption options={options} />
    }
    if (type === 2) {
      return <MultiOption options={options} />
    }
    if (type === 3) {
      return <JudgeOption options={options} />
    }
    if (type === 4) {
      return <CompletionOption options={options} />
    }
    if (type === 5) {
      return <AnswerOption answer={myAnswer} disabled={disabled}/>
    }

    return null;
  }

  function studentAnswer(type: number, ques: QuestionItem) {
    let _answer: string | string[] = '';
    const { options, myAnswer } = ques;
    if ([1, 2].includes(type)) {
      options.map((item, index) => {
        if (myAnswer.indexOf(item.id) >= 0) {
          _answer += optionsNum[index];
        }
        return item;
      })
    }
    if (type === 3) {
      options.map(item => {
        if (myAnswer.indexOf(item.id) >= 0) {
          _answer = item.option;
        }
        return item;
      })
    }

    if (type === 5) {
      _answer = myAnswer;
    }

    return _answer;
  }

  // 回显正确答案的
  function renderAnswer(type: number, ques: QuestionItem) {
    let _answer: string | string[] = '';
    const { options, answer } = ques;
    if ([1, 2].includes(type)) {
      options.map((item, index) => {
        if (item.tag === 1) {
          _answer += optionsNum[index];
        }
        return item;
      });
    }
    if (type === 3) {
      options.map(item => {
        if (item.tag === 1) {
          _answer = item.option;
        }
        return item;
      })
    }
    if (type === 4) {
      options.map((item, index) => {
        if (index === 0) {
          _answer = item.option;
          return item;
        }
        _answer += ` | ${item.option}`;
        return item;
      });
    }
    if (type === 5) {
      _answer = answer;
    }

    return _answer;
  }

  function changeCorrect(index: number, index2: number, status: 0 | 1) {
    let newData = [...questionList];
    let _data = newData[index].questions[index2];
    newData[index].questions[index2].isCorrect = status;
    newData[index].questions[index2].myGrade = status === 1 ? _data.grade : 0;
    setQuestionList(newData);
  }

  function changeGrade(e: any, index: number, index2: number) {
    let newData = [...questionList];
    newData[index].questions[index2].myGrade = e;
    setQuestionList(newData);
  }

  function computedGrade(questions: QuestionItem[]): number {
    let grade = 0;
    questions && questions.map(item => {
      grade += item.myGrade;
      return item;
    })
    return grade;
  }

  function handleStar(firstIndex: number, secondIndex: number, star: 0 | 1) {
    setIsLoading(true);
    let newData = [...questionList];
    const { questionType } = newData[firstIndex];
    const { id } = newData[firstIndex].questions[secondIndex];
    const params = {
      examID: testInfo.id,
      questionType,
      questionID: id,
    };
    if (star === 0) {
      addStar(params).then((res: any) => {
        setIsLoading(false);
        if (res && res.code === 0) {
          newData[firstIndex].questions[secondIndex].star = 1;
          setQuestionList(newData);
        } else {
          res && message.error(res.msg || '标记失败！');
        }
      })
    } else {
      removeStar(params).then((res: any) => {
        setIsLoading(false);
        if (res && res.code === 0) {
          newData[firstIndex].questions[secondIndex].star = 0;
          setQuestionList(newData);
        } else {
          res && message.error(res.msg || '标记失败！');
        }
      })
    }
  }

  return (
    <div className="content-center">
      <Spinner loading={isLoading} />
      <ul className="type-list">
        {
          questionList.map((data, index) => {
            return (
              <li className="type-list-li" key={index}>
                <div className="type-title">
                  <div>
                    {data.title}
                    {isSee && <span>(共{data.questions.length}题，合计{computedCount(data.questions).toFixed(1)}分)</span>}
                  </div>
                  {(isReview || isView) && (
                    <div>
                      共{data.questions.length}题，大题得分：{computedGrade(data.questions).toFixed(1)} ，大题满分：{computedCount(data.questions).toFixed(1)}
                    </div>
                  )}
                </div>
                <ul className="ti-list">
                  {
                    data.questions.map((ques: QuestionItem, index2) => {
                      return (
                        <li className="ti-list-li" key={index2} id={ques.id}>
                          <div className="top">
                            <div><span>{index2 + 1}.</span> {ques.question}</div>
                            {renderOptions(data.questionType, ques)}
                            <div className="analysis">
                              {
                                isView && (
                                  <div className="analysis-result">
                                    <div className="res">
                                      {ques.isCorrect === 0 ? (
                                        <CloseCircleOutlined style={{ color: 'red' }} />
                                      ) : <CheckCircleOutlined style={{ color: '#4DA635' }} />}
                                      <span className="text">{ques.isCorrect === 0 ? '答错了' : '答对了'}</span>
                                    </div>
                                    <div className="collect">
                                      {
                                        ques.star === 1 ? <StarOutlined style={{ color: '#FE8545' }} /> :
                                          <StarOutlined />
                                      }

                                      <span className="text" onClick={() => handleStar(index, index2, ques.star)}>收藏</span>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                isView && (
                                  <div className="analysis-row">
                                    <div className="analysis-row-title">学员得分：</div>
                                    <div className="analysis-row-content">{ques.myGrade.toFixed(1)} (本题分数：{ques.grade.toFixed(1)})</div>
                                  </div>
                                )
                              }
                              {
                                [1, 2, 3].includes(data.questionType) && (
                                  <div className="analysis-row">
                                    <div className="analysis-row-title">学员答案：</div>
                                    <div className={classnames('analysis-row-content', {
                                      error: ques.isCorrect === 0,
                                      right: ques.isCorrect === 1
                                    })}>{studentAnswer(data.questionType, ques)}</div>
                                  </div>
                                )
                              }
                              {
                                [1, 2, 3, 5].includes(data.questionType) && (
                                  <div className="analysis-row">
                                    <div className="analysis-row-title">正确答案：</div>
                                    <div className="analysis-row-content">{renderAnswer(data.questionType, ques)}</div>
                                  </div>
                                )
                              }
                              <div className="analysis-row">
                                <div className="analysis-row-title">解释说明：</div>
                                <div className="analysis-row-content">{ques.parsing}</div>
                              </div>
                            </div>
                          </div>
                          {
                            // isReview &&
                             (
                              <div className="rate">
                                <div className="rate-li">
                                  <div className="rate-li-left">判断：</div>
                                  <div className="rate-li-right">
                                    <i
                                      className={classnames('icon', { right: ques.isCorrect === 1 })}
                                      onClick={() => changeCorrect(index, index2, 1)}
                                    >
                                      <CheckOutlined />
                                    </i>
                                    <i
                                      className={classnames('icon', { error: ques.isCorrect === 0 })}
                                      onClick={() => changeCorrect(index, index2, 0)}
                                    >
                                      <CloseOutlined />
                                    </i>
                                  </div>
                                </div>
                                <div className="rate-li">
                                  <div className="rate-li-left">得分：</div>
                                  <div className="rate-li-right">
                                    <InputNumber min={0} size="small" value={ques.myGrade} max={ques.grade} onChange={(e) => changeGrade(e, index, index2)} />
                                  </div>
                                </div>
                                <div className="rate-li">
                                  <div className="rate-li-left">满分：</div>
                                  <div className="rate-li-right">{ques.grade.toFixed(1)}</div>
                                </div>
                              </div>
                            )
                          }
                        </li>
                      )
                    })
                  }
                </ul>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default QuestionList;
